import { useStore } from '@xyflow/react'

export default function ViewportLogger() {
  const transform = useStore((s) => s.transform)
  const [x, y, zoom] = transform
  return (
    <div className="text-xs bg-background/80 border border-border rounded px-2 py-1 shadow-sm">
      <div className="font-semibold">Viewport</div>
      <div>x: {Math.round(x)}</div>
      <div>y: {Math.round(y)}</div>
      <div>z: {zoom.toFixed(2)}</div>
    </div>
  )
}
